import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();
// const token = cookies.get("authToken");
interface AuthResponse {
  token: string;
}
export const registerApi = async (
  url: string,
  name: string,
  email: string,
  mobile: string,
  password: string
) => {
  try {
    const response = await axios.post<AuthResponse>(`${url}/login/Create`, {
      LoginType: 1,
      name,
      email,
      mobile,
      password,
    });
    cookies.set("authToken", response.data.token, { maxAge: 86400 });
    // console.log("registering", response);
    return response;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};
export const loginApi = async (
  url: string,
  email: string,
  password: string
) => {
  try {
    const response = await axios.post<AuthResponse>(`${url}/login`, {
      Type: 1,
      email,
      password,
    });

    if (response.status === 200 && response.data?.token) {
      // console.log(response.data);
      cookies.set("authToken", response.data.token, { maxAge: 86400 });

      return response;
    } else {
      return false;
    }
  } catch (error: any) {
    if (error.response) {
      return error.response.data;
    } else {
      console.error("Login error:", error);
      return false;
    }
  }
};
